import 'core-js/stable';
import 'regenerator-runtime/runtime';
import FontFaceObserver from 'fontfaceobserver';
import { render as renderCore } from 'ia-react-core';
import logger from './utils/logger';
import ConfiguredApp from './app';

const render = () => {
  renderCore(ConfiguredApp);
};

const montserrat = new FontFaceObserver('Montserrat');

const openSans = new FontFaceObserver('Open Sans');
const muoto = new FontFaceObserver('Muoto');

Promise.all([
  montserrat.load(),
  openSans.load(),
  muoto.load(),
]).catch(() => {
  logger.warn('Fonts could not be loaded');
}).finally(() => {
  render();
});
